import { Form, Input, Select } from "antd";
import { useCallback, useEffect, useState } from "react";
import { responseNotification } from "../../../utils/notify";
import { adminServices } from "../../../utils/services";
import { SubmitResetBtn } from "../../common";
import { useSelector } from "react-redux";
import React from "react";
import { jcTypeArray } from "../../../utils";
import axios from "axios";
const { Option, OptGroup } = Select;

const AddService = ({ visibleData, services = [], onCloseMethod }: any) => {
  const { token } = useSelector((state) => (state as any)?.authReducer);
  const initialState = useSelector((state) => (state as any)?.authReducer);
  const [type, setType] = useState(initialState?.type);
  const [error, setError] = useState("");
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [serviceType, setServiceType] = useState<any>("JC_COMMERCE");
  const [serviceData, setServiceData] = useState<any>(undefined);
  const [routerService, setRouterService] = useState<any>({
    loading: false,
    data: null,
  });
  const getRouterService = useCallback(async () => {
    setRouterService({ loading: true, data: null });

    const encodedUrl = `${process.env.REACT_APP_AUTH_API}`;
    axios
      .get(`${encodedUrl}/merchant-service/by-type?Type=${type}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setRouterService({ loading: false, data: res.data });
      })
      .catch((err) => {
        setRouterService({ loading: false, data: [] });
        console.error("Type: Error", err);
      });
  }, [type]);

  const getServices = routerService?.data?.services || [];

  useEffect(() => {
    getRouterService();
  }, [getRouterService]);



  const onSubmit = async (data: any) => {
    setLoading(true);

    const readyData = data && {
      serviceName: data.serviceName,
      apiPath: data.apiPath,
      methodType: data.methodType,
      type: type,
    };

    if (serviceData) {
      await fetch(`${process.env.REACT_APP_AUTH_API}/merchant-service`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...readyData,
          id: serviceData?.id,
          deleted: false,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Service Updated Successfully", "success");
            form.resetFields();
            if (onCloseMethod) {
              onCloseMethod();
            }
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else {
      await fetch(`${process.env.REACT_APP_AUTH_API}/merchant-service`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(readyData),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Service Create Successfully", "success");
            form.resetFields();
            if (onCloseMethod) {
              onCloseMethod();
            }
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  useEffect(() => {
    if (visibleData) {
      setServiceData(visibleData);
      setServiceType(visibleData?.type);
    }
  }, [visibleData]);

  useEffect(() => {
    if (serviceData) {
      setServiceType(serviceData?.type);
      form.resetFields(Object.keys(visibleData));
      form.resetFields();
    }
  }, [serviceData, form, visibleData]);

  const isExist = useCallback(
    (service: string | number) => {
      const hash = {} as any;

      getServices?.map((item: { name: string | number }) => {
        if (item?.name) {
          hash[item?.name] = item;
        }
        return true;
      });
      if (hash[service]) {
        return true;
      }
    },
    [getServices]
  );
  const filteredAdminServices = adminServices
  // eslint-disable-next-line array-callback-return
  ?.map((service) => {
    if (!service?.sub?.length) {
      if (!isExist(`${service?.name}`)) {
        return service;
      }
    } else {
      const subs = service?.sub?.filter(
        (item) => !isExist(`${service?.name} ${item?.name}`)
      );
      if (subs?.length) {
        return {
          ...service,
          sub: subs,
        };
      }
    }
  })

  ?.filter((item) => item);
  return (
    <>
      <Form
        name="control-hooks"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        onFinish={onSubmit}
        form={form}
        layout="vertical"
        initialValues={{
          ...serviceData,
        }}
      >
       <Form.Item initialValue={type}>
          <Select
            placeholder="Service Type"
            onChange={(val) => setType(val)}
            value={type}
          >
            {Object.values(jcTypeArray)?.map((type, i) => (
              <Option value={type} key={i}>
                {type.replace("_", " ")}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
  hasFeedback
  label="Name"
  name="serviceName"
  rules={[
    {
      required: !visibleData,
      message: "Name is Required!",
    },
  ]}
>
  <Select placeholder="Select Service" disabled={visibleData}>
    {filteredAdminServices?.map((service, index) => {
      if (service?.sub?.length > 0) {
        return (
          <OptGroup
            label={service.name}
            key={`group-${service.name}-${index}`}
          >
            {service.sub.map((sub, subIndex) => (
              <Option
                value={`${service.name} ${sub.name}`}
                key={`option-${service.name}-${sub.name}-${subIndex}`}
              >
                {sub.name}
              </Option>
            ))}
          </OptGroup>
        );
      } else {
        return (
          <Option
            value={service.name}
            key={`option-${service.name}-${index}`}
          >
            {service.name}
          </Option>
        );
      }
    })}
  </Select>
</Form.Item>
        <Form.Item
          hasFeedback
          label="API Path"
          rules={[
            {
              required: true,
              message: "API path is Required!",
            },
          ]}
          name="apiPath"
          initialValue={serviceData?.apiPath}
        >
          <Input id="apiPath" type="text" placeholder="Enter API Path" />
        </Form.Item>
        <Form.Item
          hasFeedback
          label="Method Type"
          rules={[
            {
              required: true,
              message: "Method type is Required!",
            },
          ]}
          name="methodType"
          initialValue={serviceData?.methodType}
        >
          <Input id="methodType" type="text" placeholder="Enter method Type" />
        </Form.Item>

        <SubmitResetBtn
          onClickReset={() => {
            form?.resetFields();
          }}
          disabled={loading || !!error}
          loading={loading}
        />
      </Form>
    </>
  );
};

export default AddService;
